import * as DateF from 'date-fns'
import React, { useMemo } from 'react'
import styled, { css } from 'styled-components'

import { Numeric } from '@blade/ui-kit'
import { Referee } from '@root/entities/referral/model'
import { DATE_FORMAT } from '@root/shared'

export const RefereeItem: React.FC<{
  referee: Referee.Referee
  darkBg?: boolean
}> = ({ referee, darkBg = false }) => {
  const fullName = useMemo(() => Referee.displayName(referee), [referee])

  return (
    <ItemRoot $darkBg={darkBg}>
      <PrimaryText>{fullName}</PrimaryText>
      <SecondaryText>
        {DateF.format(referee.referralDate, DATE_FORMAT.dd_MM_yy)}
      </SecondaryText>
      <PrimaryText
        css={css`
          text-align: right;
        `}
      >
        <Numeric
          value={referee.tradingProfitUsd}
          currency="$"
          preset="currency-amount-short"
        />
      </PrimaryText>
    </ItemRoot>
  )
}

const ItemRoot = styled.div<{ $darkBg: boolean }>`
  height: 40px;
  display: grid;
  grid-template-columns: 50% auto 1fr;
  align-items: center;
  padding-inline: 12px;

  background: ${({ $darkBg }) => ($darkBg ? `rgba(0 0 0 / 50%)` : undefined)};
`

const PrimaryText = styled.div`
  font-weight: 600;
  font-size: 12px;
  color: var(--text-12);
`

const SecondaryText = styled.div`
  font-weight: 600;
  font-size: 12px;
  color: var(--text-9);
`
